
export function wordParagraphId(state) {
    return state.wordParagraphId
}
